const ewtReportRoute = {
  public: [],
  // auth: [
  //   {
  //     name: 'ewt_report',
  //     path: '/finance-and-accounting/ewt-report',
  //     component: EwtReport,
  //   },
  // ],
};

export default ewtReportRoute;
